import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { UPGRADE_POPUP_EVENT } from '../utils/upgradePopup';

// Phải đặt BÊN TRONG <Router> (dùng useNavigate)
const UpgradePopupHost = () => {
  const navigate = useNavigate();
  const [popup, setPopup] = useState(null);

  useEffect(() => {
    const onShow = (e) => setPopup(e.detail || {});
    window.addEventListener(UPGRADE_POPUP_EVENT, onShow);
    return () => window.removeEventListener(UPGRADE_POPUP_EVENT, onShow);
  }, []);

  if (!popup) return null;

  const close = () => setPopup(null);
  const upgrade = () => {
    setPopup(null);
    navigate('/subscription');
  };

  return (
    <div
      role="dialog"
      aria-modal="true"
      onClick={close}
      style={{
        position: 'fixed', inset: 0, zIndex: 11000, background: 'rgba(0,0,0,0.5)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        style={{
          background: 'white', borderRadius: 16, padding: 24, maxWidth: 380, width: '100%',
          textAlign: 'center', boxShadow: '0 12px 40px rgba(0,0,0,0.3)'
        }}
      >
        <div style={{ fontSize: '2.5rem', marginBottom: 8 }}>🔒</div>
        <h3 style={{ margin: '0 0 8px', fontSize: '1.2rem', fontWeight: 700, color: '#1f2937' }}>
          {popup.title || 'Cần nâng cấp gói'}
        </h3>
        <p style={{ margin: '0 0 20px', fontSize: '0.95rem', lineHeight: 1.5, color: '#4b5563' }}>
          {popup.message}
        </p>
        <button
          type="button"
          onClick={upgrade}
          style={{
            width: '100%', background: 'linear-gradient(135deg, #10b981 0%, #059669 100%)', color: 'white',
            border: 'none', padding: 14, borderRadius: 12, fontSize: '1rem', fontWeight: 700,
            cursor: 'pointer', marginBottom: 8
          }}
        >
          🚀 Nâng cấp ngay
        </button>
        <button
          type="button"
          onClick={close}
          style={{
            width: '100%', background: 'transparent', color: '#6b7280', border: 'none',
            padding: 10, fontSize: '0.95rem', cursor: 'pointer'
          }}
        >
          Để sau
        </button>
      </div>
    </div>
  );
};

export default UpgradePopupHost;
